export const isAdmin = state => {
  const { user } = state.user;

  return !user._id || user.role > 3;
};

export const moreThan = role => state => {
  const { user } = state.user;
  return !user._id || user.role >= role;
};
